export enum ImageClass {
  STORE_LOGO = 'STORE_LOGO',
  STORE_REPRESENTATIVE = 'STORE_REPRESENTATIVE',
  STORE_MAIN_VIEW = 'STORE_MAIN_VIEW',
  STORE_INNER_FRONT = 'STORE_INNER_FRONT',
  STORE_INNER_LEFT = 'STORE_INNER_LEFT',
  STORE_INNER_RIGHT = 'STORE_INNER_RIGHT',
  STORE_ENTRANCE = 'STORE_ENTRANCE',
  DESIGN_STORE_HOME = 'DESIGN_STORE_HOME',
  DESIGN_LIST_A = 'DESIGN_LIST_A',
  DESIGN_LIST_B = 'DESIGN_LIST_B',
  DESIGN_ROOKIE_LIST = 'DESIGN_ROOKIE_LIST',
  DESIGN_HOME_BRAND = 'DESIGN_HOME_BRAND',
  DESIGN_HOME_PRODUCT = 'DESIGN_HOME_PRODUCT',
  MAKING_PROCESS = 'MAKING_PROCESS',
  BRAND_MOBILE_HOME_1 = 'BRAND_MOBILE_HOME_1',
  BRAND_MOBILE_HOME_2 = 'BRAND_MOBILE_HOME_2',
  BRAND_MOBILE_HOME_3 = 'BRAND_MOBILE_HOME_3',
  BRAND_PC_HOME_1 = 'BRAND_PC_HOME_1',
  BRAND_PC_HOME_2 = 'BRAND_PC_HOME_2',
  BRAND_TRPC_LOGO = 'BRAND_TRPC_LOGO',
  HOME_MEAL_STORE = 'HOME_MEAL_STORE',
  TRADITIONAL_ALCOHOL_STORE = 'TRADITIONAL_ALCOHOL_STORE',
  STORE = 'STORE',
  BREWERY = 'BREWERY',
  PROD_REPRESENTATIVE = 'PROD_REPRESENTATIVE',
  PROD_OPTIONAL = 'PROD_OPTIONAL',
  PROD_VIEW_360 = 'PROD_VIEW_360',
  CHANNEL_PROD_REPRESENTATIVE = 'CHANNEL_PROD_REPRESENTATIVE',
  CHANNEL_PROD_OPTIONAL = 'CHANNEL_PROD_OPTIONAL',
  CHANNEL_PROD_MATERIAL = 'CHANNEL_PROD_MATERIAL',
  CHANNEL_PROD_TAG = 'CHANNEL_PROD_TAG',
  CHANNEL_PROD_BARCODE = 'CHANNEL_PROD_BARCODE',
  BARCODE = 'BARCODE',
  RELATION_PROD_REPRESENTATIVE = 'RELATION_PROD_REPRESENTATIVE',
  RELATION_PROD_OPTIONAL = 'RELATION_PROD_OPTIONAL',
  STORE_PROFILE = 'STORE_PROFILE',
  IMAGE = 'IMAGE',
  STORE_NEWS = 'STORE_NEWS',
  SALE_EVENT = 'SALE_EVENT',
  USER_DEFINITION = 'USER_DEFINITION',
  SE3_EXTRACT_IMAGE = 'SE3_EXTRACT_IMAGE',
  BELONG_STORE_LOGO = 'BELONG_STORE_LOGO',
  MALL_PC_REPRESENTATIVE = 'MALL_PC_REPRESENTATIVE',
  MALL_MOBILE_REPRESENTATIVE = 'MALL_MOBILE_REPRESENTATIVE',
  MALL_LOGO = 'MALL_LOGO',
  REPRESENT = 'REPRESENT',
  OPTIONAL = 'OPTIONAL',
  BELONG_STORE_REPRESENTATIVE = 'BELONG_STORE_REPRESENTATIVE',
}
